import React from "react";
import Portal_Section_3 from "./Portal_Section_3";
import GR_Section from "./GR_Section";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import TestimonialSection from "../HomePage/TestimonialSection/TestimonialSection";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import BgvStepsSection from "../ItPage/BgvStepsSection/BgvStepsSection";
import BrandCarousel from "../ItPage/BrandCarousel/BrandCarousel";
import { Helmet } from "react-helmet";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";
const GR_Portal_Image = `${digitalOceanURL}/Portal_Image/GR_Portal_Img.png`;
const GR_Portal_Small_Image = `${digitalOceanURL}/Portal_Image/GR_Portal_small_Img.png`;

const jsonLdData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SoftwareApplication",
      "@id": "https://hirestar.io/grievance-portal#software",
      name: "HireStar.io Grievance Portal",
      operatingSystem: "Web",
      applicationCategory: "BusinessApplication",
      description:
        "HireStar.io's Grievance Portal enables employees and HR teams to efficiently report and address critical issues such as moonlighting and absconding, ensuring a transparent and secure grievance management process.",
      url: "https://hirestar.io/grievance-portal",
      publisher: {
        "@id": "https://hirestar.io/#organization",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://hirestar.io/grievance-portal",
      url: "https://hirestar.io/grievance-portal",
      name: "HireStar.io Grievance Portal",
      description:
        "Access HireStar.io's Grievance Portal to report and manage workplace issues effectively, leveraging AI & Blockchain technology for secure and transparent grievance handling.",
      publisher: {
        "@id": "https://hirestar.io/#organization",
      },
    },
    {
      "@type": "Organization",
      "@id": "https://hirestar.io/#organization",
      name: "HireStar.io",
      url: "https://hirestar.io",
      logo: {
        "@type": "ImageObject",
        url: "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/HeaderAssets/hireStar.svg",
      },
      sameAs: [
        "https://in.linkedin.com/showcase/hirestar.io/",
        "https://www.facebook.com/hirestario",
        "https://twitter.com/Hirestario?t=YOq_b92bZL8gZxDuS21hRQ&s=09",
        "https://www.instagram.com/hirestar.io/",
      ],
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://hirestar.io/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Grievance Portal",
          item: "https://hirestar.io/grievance-portal",
        },
      ],
    },
  ],
};

export default function GR_Portal() {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
        <title>
          Simplify HR Tasks with Hirestar.io’s Grievance Reporting Portal |
          Ensure Workplace Integrity
        </title>
        <meta
          name="description"
          content="Streamline HR operations with Hirestar.io’s Grievance Reporting Portal. Efficiently manage issues like moonlighting, absconding, and offer shopping to uphold workplace integrity and transparency."
        />
        <meta
          name="keywords"
          content="Hirestar.io grievance reporting portal, HR grievance management, workplace integrity, moonlighting, absconding, offer shopping, HR issue resolution, employee misconduct reporting, HR compliance tools, Hirestar.io solutions"
        />
        <meta
          property="og:title"
          content="Simplify HR Tasks with Hirestar.io’s Grievance Reporting Portal | Ensure Workplace Integrity"
        />
        <meta
          property="og:description"
          content="Streamline HR operations with Hirestar.io’s Grievance Reporting Portal. Efficiently manage issues like moonlighting, absconding, and offer shopping to uphold workplace integrity and transparency."
        />
        <meta
          property="og:url"
          content="https://hirestar.io/grievance-portal"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/Portal_Image/GR_Portal_Img.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:site_name" content="Hirestar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Simplify HR Tasks with Hirestar.io’s Grievance Reporting Portal |
          Ensure Workplace Integrity"
        />
        <meta
          name="twitter:description"
          content="Streamline HR operations with Hirestar.io’s Grievance Reporting Portal. Efficiently manage issues like moonlighting, absconding, and offer shopping to uphold workplace integrity and transparency."
        />
        <meta
          name="twitter:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/Portal_Image/GR_Portal_Img.png"
        />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <div className=" relative  blog_bg_image background_color">
        {/* ---------------------------show this for lg and md device------------------------------------- */}
        <div className="lg:relative    flex flex-col   lg:mx-12 lg:top-2 top_image_gap3">
          <div className=" flex flex-col lg:relative  lg:right-10 leading-tight z-[2] GR-portal-box ">
            <div className="p-2 mt-8  lg:ml-16 top_spacing">
              <div
                aria-label="Introducing the Hirestar.io Grievance Reporting Portal"
                className="text-wrap text-[32px] md:text-[46px] lg:text-[46px] text mt-14 lg:mt-0 md:mt-20 text-heading-container  font-semibold font-[poppins] text-center heading"
              >
                {/* <h1 className="text-[32px] md:text-[46px] lg:text-[46px] text" aria-label="Introducing the Hirestar.io Grievance Reporting Portal">
                  Introducing the Hirestar.io
                  <span className="text-[#1783C4]"><br /> Grievance Reporting Portal</span>
                </h1> */}
                {/* updated code */}
                <h1 aria-label="Introducing the Hirestar.io ">
                  Introducing The Hirestar.io
                </h1>
                <p
                  className="text-[#1783C4] "
                  aria-label="Grievance Reporting Portal"
                >
                  Grievance Reporting Portal
                </p>
                {/* ---------------------------- */}
              </div>
              <div className="text-wrap px-2 lg:px-0 md:px-0  font-[poppins] font-[16px] mt-2 md:mt-6 lg:mt-6 text-center paragraph">
                <p>
                  Streamline hiring with secure, blockchain-based background
                  checks <br className="hidden md:block lg:block " />
                  Trust Hirestar.io for verified and transparent employee
                  screening
                </p>
              </div>
            </div>

            {/* --------------------------buttons-------------------- */}
            <ButtonComponent
              arialLabel={
                "Get in touch with an expert to know more about Grievance Reporting Portal"
              }
            />
          </div>

          {/* -------------------------show this for large device-------------------------------------- */}
          <div className="large-image">
            {/* Home Image */}
            <img
              className=" sm:mb-12 lg:relative w-full home-image"
              alt="large-screen hero img for gr portal "
              title="hero image for gr portal"
              src={GR_Portal_Image}
              loading="lazy"
            />
          </div>

          {/* -------------------------show this for small device-------------------------------------- */}
          <div className="relative w-full max-w-sm mx-auto small-image">
            <div className="overflow-hidden rounded-lg">
              <div className="flex transition-transform duration-300 ease-in-out mb-20">
                <img
                  src={GR_Portal_Small_Image}
                  alt="small-screen hero img for gr portal"
                  title="hero image for gr portal in small screen"
                  className="w-full h-auto flex-shrink-0"
                />
              </div>
            </div>
          </div>

          {/* ------------------------dot code to show  current image -------------------- */}
        </div>
      </div>
      <div className="mt-20">
        <BrandCarousel />
      </div>
      <div className="top_spacing">
        <GR_Section />
      </div>
      <Portal_Section_3
        heading="Grievance Reporting Portal"
        Paragraph="Overcome hiring challenges with a portal that streamlines offers and tackles moonlighting, offer shopping, and late joining—ensuring a smooth transition from offer to onboarding."
        section="GR_Portal"
      />

      <BgvStepsSection />
      <div>
        <TestimonialSection />
      </div>

      <FaqComponent />

      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
}
